var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({class:{'interest-button--disabled' : _vm.disabled},attrs:{"icon":"","elevation":_vm.disabled ? 0: 1,"color":_vm.active ? 'primary' : 'gray'},on:{"click":_vm.select}},'v-btn',_vm.size,false),[(_vm.active)?_c('v-icon',[_vm._v(" mdi-heart ")]):_c('v-icon',[_vm._v(" mdi-heart-outline ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }